import { render } from "./CertAlcoholOngoing.vue?vue&type=template&id=c888c43e&scoped=true"
import script from "./CertAlcoholOngoing.vue?vue&type=script&lang=js"
export * from "./CertAlcoholOngoing.vue?vue&type=script&lang=js"

import "./CertAlcoholOngoing.vue?vue&type=style&index=0&id=c888c43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c888c43e"]])

export default __exports__